import Types from "../actionTypes";
import { HomeReducer } from "../../models/home.model";

export const actGetQuantityHomepage = (quantity_homepage: HomeReducer) => {
  return {
    type: Types.GET_QUANTITY_HOMEPAGE,
    quantity_homepage,
  };
};
